// src/utils/portalPreview.js
// SEAM 10 VERIFIER: qview-6b2d4e91-preview
//
// "Staff preview" — a browser on which a STAFF member opened a customer's
// portal link. Such a browser must never report estimate views.
//
// WHY THE PAGE HAS TO DO THIS: a portal link (the quote email, or the staff
// "Client Portal Access" invite) mints the CUSTOMER's own identity
// (exchangePortalToken → cust-{orgId}-{customerId}). Once a staff member opens
// it, the server sees exactly the customer and cannot tell them apart.
//
// HOW: PortalLogin checks, BEFORE exchanging the link, whether a non-portal
// (staff) user is already signed in on this browser. If so it calls
// markStaffPreviewBrowser(). The mark is BROWSER-WIDE (localStorage), not per
// tab, and never cleared automatically: after that login the browser holds the
// customer's session, so a later tab — or a second customer's link opened from
// the same browser, whose "previous user" is now a portal user — would
// otherwise count as a real customer.
//
// KNOWN LIMIT (BACKLOG): staff opening the link on a different device, in a
// private window, or after signing out of Spatchy are not caught.
//
// Storage can be unavailable (private mode, blocked site data). Every access
// is wrapped; an unreadable mark reads as "not a preview".

const KEY = 'spatchy.portalStaffPreview';

export function markStaffPreviewBrowser() {
    try { localStorage.setItem(KEY, '1'); } catch { /* storage unavailable */ }
    try { sessionStorage.setItem(KEY, '1'); } catch { /* storage unavailable */ }
}

export function isStaffPreviewBrowser() {
    try { if (localStorage.getItem(KEY) === '1') return true; } catch { /* storage unavailable */ }
    try { if (sessionStorage.getItem(KEY) === '1') return true; } catch { /* storage unavailable */ }
    return false;
}
